import * as yup from 'yup'

export const managementBinderUploadSchema = yup
  .object({
    files: yup
      .array()
      .of(
        yup.object({
          mimeType: yup.string().required(),
          base64: yup.string().required(),
          filename: yup.string().required(),
          name: yup.string().required(),
          path: yup.string(),
        })
      )
      .min(1)
      .required(),
    notificationSettings: yup
      .string()
      .oneOf(['none', 'notification'])
      .required(),
  })
  .required()
